import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/close.svg'


const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = { class: "pane" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = {
  key: 1,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text" }, "提交成功", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "X",
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
        })
      ]),
      (_ctx.state.shortUrl != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[5] || (_cache[5] = [
            _createElementVNode("p", null, "根据国家对通信产品实名信息登记的要求，您需要进行身份认证后才能使用！", -1)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[6] || (_cache[6] = [
            _createElementVNode("p", null, "我们将尽快为您配送，请在收到卡后的10天内激活使用，过期将被回收哦！", -1)
          ]))),
      (_ctx.state.shortUrl!='')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "auth",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickAuth && _ctx.onClickAuth(...args)))
          }, "前往实名 " + _toDisplayString(_ctx.state.countDown || ''), 1))
        : (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "change",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
          }, "关闭"))
    ]),
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
    })
  ]))
}